import LoadMorePosts from './loadMorePosts';
import Pagination from './pagination';

const $ = jQuery.noConflict();

'use strict';
const blogSearch = {

	$domSearchInput: $('.js-search-posts'),
	$domPostCategory: $('.js-post-category'),
	$domSearchButton: $('.js-search-post-button'),
	$domDropdownSelector: $('.js-dropdown-el'),
	$domCheckBoxInputSelector: $('.js-type-checkbox'),
	$domDropdownButtonSelector: $('.js-dropdown-button'),
	$domLoader: $('.js-blog-article-loader'),
	classExampleShow: 'show-dropdown',
	tax: $('.js-article-tax-id').val(),
	status: $('.js-article-status').val(),

	init: function() {
		this.bindEvents();
		this.oneChecked();
		this.showHideDropdown();
		this.activeCategory();
	},

	bindEvents: ()=>{
		// $('input[type=\'checkbox\']').on('click', (event) => {
		// 	const categoryName = event.currentTarget.getAttribute('name');
		// 	const termId = event.currentTarget.getAttribute('id');
		//
		// 	// set dropdown values
		// 	blogSearch.$domPostCategory.text(categoryName);
		// 	blogSearch.tax = termId;
		// });
		// send request
		blogSearch.$domSearchButton.on('click', ()=> {
			LoadMorePosts.page = 1;
			const searchValLength = blogSearch.$domSearchInput.val().length;
			if (searchValLength >= 3 || searchValLength === 0) {
				blogSearch.sendRequest(
					blogSearch.prepareData()
				);
			}
		});
	},


	oneChecked: function() {
		blogSearch.$domCheckBoxInputSelector.on('change', function() {
			blogSearch.$domCheckBoxInputSelector.not(this).prop('checked', false);
		});
	},

	showHideDropdown: function() {
		$('body').on('click', function() {
			blogSearch.$domDropdownSelector.removeClass('show-dropdown');
			$('.dropdown-icon').removeClass('active-dropdown');
			$('.restaurant-guide-block__filter-btn').removeClass('active-btn');
		});
		blogSearch.$domDropdownButtonSelector.on('click', function(event) {
			event.stopPropagation();
			if (blogSearch.$domDropdownSelector.hasClass('show-dropdown')) {
				blogSearch.$domDropdownSelector.removeClass('show-dropdown');
				$('.dropdown-icon').removeClass('active-dropdown');
				$('.restaurant-guide-block__filter-btn').removeClass('active-btn');

			} else {
				blogSearch.$domDropdownSelector.addClass('show-dropdown');
				$('.dropdown-icon').addClass('active-dropdown');
				$('.restaurant-guide-block__filter-btn').addClass('active-btn');

			}
		});
	},

	activeCategory: function() {
		blogSearch.$domCheckBoxInputSelector.on('change', function() {
			$('.blog-listing__dropdown-option').removeClass('is-active-checkbox');
			if(blogSearch.$domCheckBoxInputSelector.is(':checked')) {
				$(this).parent().addClass('is-active-checkbox');
				if (blogSearch.$domDropdownSelector.hasClass('show-dropdown')) {
					blogSearch.$domDropdownSelector.removeClass('show-dropdown');
					$('.dropdown-icon').removeClass('active-dropdown');
				}
			}
		});
	},

	sendRequest: (data)=> {
		blogSearch.showLoader(false);
		$.ajax({
			method: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data: data,
			success: function(response) {
				if (response.success) {
					blogSearch.successResponse(response);
				}
			}, complete: ()=>{
				setTimeout(()=>{
					blogSearch.showLoader(true);
				}, 500);
			}
		});
	},

	successResponse: (response)=>{
		$('.js-blog-post-message').remove();
		$('.js-listing').empty();
		$('.js-listing').append(response.data.posts);

		let page = 0;
		let status = 'search';
		if (!response.data.searchValue) {
			page = 1;
			status = 'posts';
		}
		// generate pagination
		Pagination.generatePagination(response.data.max, LoadMorePosts.page, status);
		// change url address
		LoadMorePosts.changeUrl(page, status);
	},

	prepareData: (paged = 1)=>{
		const formValues = [];
		formValues.push({name: 'action', value: 'search-posts'});
		formValues.push({name: 'status', value: blogSearch.status});
		formValues.push({name: 'tax', value: blogSearch.tax});
		formValues.push({name: 'paged', value: paged});
		formValues.push({name: 'search-value', value: blogSearch.$domSearchInput.val()});
		// return data
		return formValues;
	},

	showLoader: (active)=>{
		blogSearch.$domLoader.toggleClass('turnoff-loader', active);
	},
};

export default blogSearch;
